import React, { useState } from 'react';
import { Eye, EyeOff, Lock } from 'lucide-react';
import Button from '../ui/Button';

export const validateConfirmPassword = (password = '', confirmPassword = '') => {
  if (!confirmPassword) return 'Please confirm your password';
  if (password !== confirmPassword) return 'Passwords do not match';
  return '';
};

const ConfirmPasswordField = ({
  id = 'confirmPassword',
  label = 'Confirm password',
  value,
  password,
  onChange,
  onBlur,
  error = '',
  touched = false,
  required = true
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const hasValue = value.length > 0;
  const matches = hasValue && password === value;
  const showStatus = touched && hasValue && !error;

  const describedByIds = [];
  if (showStatus) describedByIds.push(`${id}-status`);
  if (error) describedByIds.push(`${id}-error`);

  return (
    <div>
      <label htmlFor={id} className="text-sm font-medium text-[var(--color-text-secondary)]">
        {label}
      </label>
      <div className="relative mt-2">
        <Lock className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-[var(--color-text-muted)]" />
        <input
          id={id}
          type={showPassword ? 'text' : 'password'}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onBlur={onBlur}
          placeholder="••••••••"
          autoComplete="new-password"
          maxLength={64}
          required={required}
          aria-invalid={Boolean(error)}
          aria-describedby={describedByIds.join(' ')}
          className={`h-12 w-full rounded-xl border bg-[var(--color-surface-input)] px-10 pr-12 text-[var(--color-text-primary)] placeholder:text-[var(--color-text-muted)] focus:outline-none focus:ring-2 focus:ring-indigo-500/25 focus:border-indigo-500/40 ${
            error ? 'border-rose-500/60' : 'border-[var(--color-border)]'
          }`}
        />
        <Button
          type="button"
          variant="ghost"
          size="iconSm"
          aria-label={showPassword ? 'Hide confirm password' : 'Show confirm password'}
          onClick={() => setShowPassword((current) => !current)}
          className="absolute inset-y-0 right-1.5 my-auto"
        >
          {showPassword ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
        </Button>
      </div>

      {showStatus && (
        <p
          id={`${id}-status`}
          className={`mt-1 text-xs ${matches ? 'auth-success' : 'auth-danger'}`}
          aria-live="polite"
        >
          {matches ? 'Passwords match' : 'Passwords do not match'}
        </p>
      )}

      {error && (
        <p id={`${id}-error`} role="alert" aria-live="assertive" className="mt-1 text-xs auth-danger">
          {error}
        </p>
      )}
    </div>
  );
};

export default ConfirmPasswordField;
